import { triggerAsyncId } from 'async_hooks';
import React from 'react';
import { CoachIcon } from '../svg/CoachIcon';
import { GamerIcon } from '../svg/GamerIcon';
import { CoachDollar } from '../svg/scholarships/CoachDollar';
import { CoachScholar } from '../svg/scholarships/CoachScholar';
import { Controller } from '../svg/scholarships/Controller';
import { DollarCard } from './card/DollarCard';
import { OpporCard } from './card/OpporCard';

type Props = {
    className?: string;
};

export const DollarCurrentDark: React.FC<Props> = ({ className }) => {
    return (
        <div className="scholar-dollar-current dark">
            <div className="container slim">
                <div className="content">
                    <h2 className="tagline white">{'Current Esports Scholarship Opportunities'}</h2>
                    <p className="description white">
                        {
                            'We offer multiple opportunities to find and gain scholarships. These opportunities can include esports competitions, traditional essay competitions, coding challenges and individual skill-based scholarships.'
                        }
                    </p>
                    <div className="dollar-grid">
                        <DollarCard
                            dark={false}
                            description={
                                'Compete in the largest recruiting event. Hosted four times annually with prizing up to $1,000.'
                            }
                            tagline={'Carry2College'}
                            buttonText={'more info'}
                            buttonLink={'https://carry2college.staypluggedin.gg'}
                            imageSrc={'/images/sponsor-logos/c2c-dark.png'}
                            width={85}
                            height={330}
                            needsPadd={false}
                        />
                        <DollarCard
                            dark={false}
                            description={'Compete on LAN in front of colleges with Scholar Dollars on the line.'}
                            tagline={'LAN Showcases'}
                            buttonText={'more info'}
                            buttonLink={'https://helix-showcase.staypluggedin.gg'}
                            imageSrc={'/images/sponsor-logos/helix-showcase.png'}
                            width={50}
                            height={80}
                            needsPadd={false}
                        />
                        <DollarCard
                            dark={false}
                            description={
                                'Earn Scholarships over the summer playing Rocket League, Valorant & Overwatch'
                            }
                            tagline={'Summer Series'}
                            buttonText={'more info'}
                            buttonLink={'https://summer-series.staypluggedin.gg'}
                            imageSrc={'/images/sponsor-logos/summer-blue.png'}
                            width={265}
                            height={51}
                            needsPadd={false}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};
